import { render, staticRenderFns } from "./jd_list.vue?vue&type=template&id=77b3f026&scoped=true"
import script from "./jd_list.vue?vue&type=script&lang=js"
export * from "./jd_list.vue?vue&type=script&lang=js"
import style0 from "./jd_list.vue?vue&type=style&index=0&id=77b3f026&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b3f026",
  null
  
)

export default component.exports